import * as R from "ramda";

const paragraph = (subContent: any[], nodeType: string) => {
  let subNodes: any[] = [];

  if (!subContent.length) {
    subNodes = [
      [
        {
          data: {},
          marks: [],
          value: "",
          nodeType: "text",
        },
      ],
    ];
  } else {
    subNodes = [subContent];
    let brIndex = R.findIndex(R.propEq("nodeType", "br"), R.last(subNodes));

    while (brIndex !== -1) {
      const last = subNodes.pop();

      const split = R.splitAt(brIndex, last);
      split[1].shift(); // remove the br node
      subNodes = R.concat(subNodes, split);
      brIndex = R.findIndex(R.propEq("nodeType", "br"), R.last(subNodes));
    }
  }

  const newData = R.map(
    (content) => ({
      data: {},
      content,
      nodeType,
    }),
    subNodes
  );

  return newData;
};

export default paragraph;
